export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${API_BASE}/api`;

export const OWNER_EMAIL = "panther.pdl.44@gmail.com";

export const PANTHER_LINKS = {
  website: "https://www.mypanther.fr/",
  facebook: "https://www.facebook.com/PantherDesignForYou/",
  instagram: "https://www.instagram.com/pantherdesignforyou/",
  questions: "https://www.mypanther.fr/questions",
};
